import {
  Box,
  Button,
  Divider,
  Rating,
  TextField,
  Typography,
} from "@mui/material";
import EmbeddedVideo from "../EmbeddedVideo/EmbeddedVideo";
import { useEffect, useState } from "react";
import api from "../../utils/api";
import { apiUrls } from "../../utils/urls";
import { useGet } from "../../hooks/api";
import { showSuccessSnackbar } from "../../utils/feedback";

export default function VideoViewer({ title, video }) {
  const { data: existingRatingData, refetch: refetchExistingRating } = useGet(
    apiUrls.testing.videoRatings(video.uuid),
    {
      staleTime: 0,
    }
  );
  const [changed, setChanged] = useState(false);
  const [rating, setRating] = useState(null);
  const [review, setReview] = useState("");
  const handleSubmitRating = async (event) => {
    event.preventDefault();
    const response = await api.post(apiUrls.testing.videoRatings(video.uuid), {
      rating: rating,
      description: review,
    });
    if (response.status != 200) {
      return;
    }
    showSuccessSnackbar("Rating Submitted!");
    setChanged(false);
    refetchExistingRating();
  };

  useEffect(() => {
    const existingRating = existingRatingData?.data[0];
    if (existingRating) {
      setRating(existingRating.rating);
      setReview(existingRating.description);
    }
  }, [existingRatingData?.data]);

  return (
    <Box>
      {title ?? (
        <Typography variant="h6" fontWeight={"bold"} pb={2}>
          {title}
        </Typography>
      )}
      <EmbeddedVideo video={video} />
      <Divider sx={{ py: 2 }} />
      <Box pt={2} component={"form"} onSubmit={handleSubmitRating}>
        <Typography variant="h6" gutterBottom>
          Rate the video!
        </Typography>
        <Typography variant="subtitle2" mb={2}>
          Video ratings help us improve the quality of our videos and deliver
          you the best learning experience possible.
        </Typography>
        <Rating
          value={rating}
          sx={{ mb: 2 }}
          onChange={(event, newValue) => {
            if (!changed) {
              setChanged(true);
            }
            setRating(newValue);
          }}
        />
        <TextField
          label="Type your review (optional)"
          fullWidth
          multiline
          rows={3}
          onChange={(event) => {
            if (!changed) {
              setChanged(true);
            }
            setReview(event.target.value);
          }}
          value={review}
        />
        <Button
          type="submit"
          variant="contained"
          sx={{ mt: 2 }}
          disabled={!changed || rating === null}
        >
          Submit
        </Button>
      </Box>
    </Box>
  );
}
